import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import styled from "styled-components/macro";

export default function VsEngNote({ slug }: { slug: string }): JSX.Element {
    if (slug !== "vseng") {
        return null;
    }
    return (<Wrapper aria-label="VsEng Information">
        <p> <b>Please note before reporting!</b></p>
        <p>
            <ul>
                <li> Product related ticket should be created at (provide link to external page)</li>
                <li>Please search the  <a href="https://devdiv.visualstudio.com/DevDiv/_wiki/wikis/DevDiv.wiki/583/Engineering-System-Tools" target="_blank" rel="noreferrer">Engineering Systems & Tools</a> wiki for help on questions you may have.</li>
                <li>Only improvement and feature suggestions to the build and test engineering systems should be made here.</li>
                <li><b>For immediate support</b> on blocking issues email <a href="mailto:vsenghelp@microsoft.com">VSEngHelp</a>.
                </li>
            </ul>
        </p>
    </Wrapper>);
}

const Wrapper = styled.div`
    padding: 2rem;
    margin: 2rem 0;
    border: 0.1rem solid var(--color-info);
    border-top: 0.4rem solid var(--color-info);
    border-radius: 0.2rem;
    box-shadow: 0px 0.3px 0.9px rgb(0 0 0 / 11%),0px 1.6px 3.6px rgb(0 0 0 / 13%);
    background-color: var(--color-surface);

    ul {
        padding-inline-start: 4rem;
        margin-block-start: 1em;
        margin-block-end: 1em;

        li {
            display: list-item;
        }
    }
`;
